<template>

    <button type="button" class="button ion-activatable" @click="goBack">
        <ion-img src="assets/images/arrow_left.png" :style="iconCss"></ion-img>
        Retour
        <ion-ripple-effect></ion-ripple-effect>
    </button>

</template>

<script>
import { IonImg, IonRippleEffect } from '@ionic/vue';

export default {
    name: "ButtonIcon",
    components: {
        IonImg, IonRippleEffect,
    },
    props: {
        href: String,
        iconHeight: {
            type: String,
            default: '30px',
        }
    },
    methods: {
        goBack: function() {
            if (this.href) {
                return this.$router.push(this.href);
            }
            return this.$router.back();
        },
    },
    computed: {
        iconCss() {
            return {
                'height': this.iconHeight,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    position: relative;
    overflow: hidden;
    width: 90px;
    height: 80px;
    padding: 4px 4px;
    text-align: center;
    border-radius: 4px;
    text-decoration: none;
    @apply flex flex-col items-center justify-center leading-none text-xs;

    ion-img {
        @apply mb-2;
    }
}
</style>
